import { FC, Fragment, useContext, useState } from 'react';
import { MoContext } from 'contexts/MoContext';
import { actionTargetsOrder, useOrdersAction } from '../Assistant/ordersActions';
import { useTranslation } from 'react-i18next';
import { MyOrder, OrderRow, FullSegment } from 'ts/shared/interfaces/MOResponse';
import { checkStatus } from 'services/myOrders';
import { showSuccess } from 'utils/utils';
import Button from 'components/ui/Button/Button';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import withErrorBoundary from '../../withErrorBoundary';

interface MoStatusProps {
  segment: FullSegment;
  orderRow: OrderRow;
  onSuccess: (row: MyOrder) => void;
}

const MoStatus: FC<MoStatusProps> = ({ segment, orderRow, ...props }) => {
  const [t] = useTranslation();
  const { activeOrder } = useContext(MoContext);
  const [isLoading, setIsLoading] = useState(false);
  const isActive =
    activeOrder?.fullSegment.orderSegId === segment.orderSegId ||
    activeOrder?.orderRow.segmentId === orderRow.segmentId;

  const onClickCheck = async () => {
    setIsLoading(true);
    const res = await checkStatus(segment);
    const status = res?.myOrder.orderRow.status;
    if (status && status !== orderRow.status) {
      props.onSuccess(res.myOrder);
      showSuccess(t('mo.status_changed', status));
    } else {
      showSuccess(t('mo.status_the_same'));
    }

    setIsLoading(false);
  };

  useOrdersAction(
    (action) =>
      action.action === 'status' &&
      actionTargetsOrder(
        action,
        {
          segmentId: orderRow.segmentId,
          altSegmentId: segment.orderSegId,
          orderId: orderRow.orderId,
          altOrderId: segment.orderId,
        },
        isActive,
      ),
    () => {
      void onClickCheck();
    },
    isActive,
  );

  return (
    <Fragment>
      <Button
        disabled={isLoading}
        onClick={onClickCheck}
        title={t(isLoading ? 'mo.loading' : 'mo.status_full')}
        className="btn btn-green btn-ssm"
        icon={faCheckCircle}
        iconclassname="mr-5"
      />
    </Fragment>
  );
};

export default withErrorBoundary(MoStatus, 'MoStatus');
